import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import css from "../../../css/agents/filters.module.css";

const Text = (props) => {
    const [fieldValue, setFieldValue] = useState(
      props.value && props.value.value ? props.value.value : ""
    );

    useEffect(() => {
        setFieldValue(
            props.value && props.value.value ? props.value.value : ""
        );
    }, [props.value, props.value.value]);

    const handleBlur = (event) => {
        const target = event.target;
        let propsValue = props.value;

        propsValue.value = target.value;
        propsValue.label = target.value;

        props.onChange(propsValue);
    };

    return (
        <input
            type="search"
            inputMode="search"
            autoComplete="off"
            id={props.id}
            name={props.name}
            value={fieldValue}
            onBlur={handleBlur}
            onChange={(e) => setFieldValue(e.target.value)}
            minLength="2"
            maxLength="255"
            placeholder="Name of Agent"
            className={css.input}
        />
    );
}

Text.propTypes = {
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    value: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
};

export default Text;
